module.exports = {
  TASK_JOB_RCV_IMPORT: {
    code: 'task-job-rcv-import',
    name: 'Job Receive Amount Import',
    uploadText: 'Please upload PRODA amount receive summary csv from PRODA site.'
  }
}
